import InformListVue from '@/views/sa/inform-list/inform-list.vue';

const basePath = '/sa/inform-list';
const role = 'sa'; // 角色身份

export const SA_INFORM_LIST_BIRTHDAY = 'sa-inform-list-birthday';
export const SA_INFORM_LIST_EXPIRED = 'sa-inform-list-expired';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: InformListVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/birthday`,
      name: SA_INFORM_LIST_BIRTHDAY,
      component: () => import(
        /* webpackChunkName: "member search" */
        `@/views/${role}/inform-list/birthday.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/expired`,
      name: SA_INFORM_LIST_EXPIRED,
      component: () => import(
        /* webpackChunkName: "member show" */
        `@/views/${role}/inform-list/expired.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
